import { useEffect, useState } from 'react';
import { Address } from 'react-daum-postcode';

import { useGetMemberCompanyInfoApi, usePostModifyMemberCompanyInfoApi } from '@/api/mypage';
import Field from '@/components/common/Field/Field';
import InputAddress from '@/components/common/Input/InputAddress/InputAddress';
import InputSelect from '@/components/common/Input/InputSelect/InputSelect';
import InputText from '@/components/common/Input/InputText/InputText';
import { positionOptions } from '@/constants/option';
import { useToastStore } from '@/store/toastStore';
import { convertPositionValue } from '@/utils/convertValue';

import * as S from './style';

const CompanyInfo = () => {
	const { openToast } = useToastStore();
	const [isOpen, setIsOpen] = useState(false);
	const [company, setCompany] = useState({
		companyName: '',
		companyEnName: '',
		position: '',
		positionReason: '',
		phone: '',
	});
	const [address, setAddress] = useState({
		zipcode: '',
		address: '',
		detailAddress: '',
	});

	const { data: companyInfo } = useGetMemberCompanyInfoApi();
	const { mutateAsync: modifyCompanyInfo } = usePostModifyMemberCompanyInfoApi();

	const handleAddress = (val: Address) => {
		setAddress({
			zipcode: val.zonecode,
			address: val.address,
			detailAddress: '',
		});
	};
	const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		const res = await modifyCompanyInfo({
			member_company_name: company.companyName,
			member_company_en_name: company.companyEnName,
			member_position: company.position === '기타(직접입력)' ? company.positionReason : company.position,
			member_company_tel: company.phone,
			member_company_zipcode: address.zipcode,
			member_company_address: address.address,
			member_company_address_detail: address.detailAddress,
		});
		if (res.data.success) {
			openToast({
				subContent: '대한화장품학회',
				content: '정보가 변경되었습니다.',
			});
		}
	};

	useEffect(() => {
		if (companyInfo) {
			setCompany({
				companyName: companyInfo.member_company_name,
				companyEnName: companyInfo.member_company_en_name,
				position: convertPositionValue(companyInfo.member_position),
				positionReason: convertPositionValue(companyInfo.member_position) === '기타(직접입력)' ? companyInfo.member_position : '',
				phone: companyInfo.member_company_tel,
			});
			setAddress({
				zipcode: companyInfo.member_company_zipcode,
				address: companyInfo.member_company_address,
				detailAddress: companyInfo.member_company_address_detail,
			});
		}
	}, [companyInfo]);

	return (
		<S.FormContainer onSubmit={onSubmit}>
			<S.FieldBox>
				<S.Title>직장정보</S.Title>
				<Field title="직장명(국문)">
					<InputText
						value={company.companyName}
						input={(e: React.ChangeEvent<HTMLInputElement>) => {
							setCompany({ ...company, companyName: e.currentTarget.value });
						}}
					/>
				</Field>
				<Field title="직장명(영문)">
					<InputText
						value={company.companyEnName}
						input={(e: React.ChangeEvent<HTMLInputElement>) => {
							setCompany({ ...company, companyEnName: e.currentTarget.value });
						}}
					/>
				</Field>
				<Field title="직위">
					<S.AddressContentBox>
						<InputSelect
							options={positionOptions}
							selectedOption={company.position}
							setSelectedOption={(label) => setCompany({ ...company, position: label })}
							defaultValue="직위선택"
						/>
						{company.position === '기타(직접입력)' && (
							<InputText
								value={company.positionReason}
								input={(e: React.ChangeEvent<HTMLInputElement>) => {
									setCompany({ ...company, positionReason: e.currentTarget.value });
								}}
								placeholder="직접 입력"
							/>
						)}
					</S.AddressContentBox>
				</Field>

				<Field title="전화 번호">
					<InputText
						value={company.phone}
						input={(e: React.ChangeEvent<HTMLInputElement>) => {
							setCompany({ ...company, phone: e.currentTarget.value });
						}}
						placeholder="‘-’없이 숫자만 입력"
					/>
				</Field>

				<Field title="주소">
					<S.AddressContentBox>
						<S.AddressBox>
							<InputText readonly value={address.zipcode} />
							<S.FindButton type="button" onClick={() => setIsOpen(true)}>
								우편번호 찾기
							</S.FindButton>
						</S.AddressBox>
						<S.AddressBox>
							<InputText readonly value={address.address} />
						</S.AddressBox>
						<S.AddressBox>
							<InputText
								value={address.detailAddress}
								input={(e: React.ChangeEvent<HTMLInputElement>) => {
									setAddress({ ...address, detailAddress: e.currentTarget.value });
								}}
								placeholder="상세주소 입력"
							/>
						</S.AddressBox>
					</S.AddressContentBox>
					{isOpen && <InputAddress setIsOpen={setIsOpen} setAddress={handleAddress} />}
				</Field>
			</S.FieldBox>
			<S.NextButton type="submit">변경완료</S.NextButton>
		</S.FormContainer>
	);
};

export default CompanyInfo;
